import {useEffect, useState} from 'react';

const MAX_STOPS_FOR_DUPLICATE_SPIDERFY = 1000;

export default function useMapControls(
  numStops,
  useClusterDefault = true,
  useDuplicateSpiderfyDefault = true,
  highLiteDuplicatesDefault = false,
) {

  const [useCluster, setUseCluster] = useState(useClusterDefault);
  const [useDuplicateSpiderfy, setUseDuplicateSpiderfy] = useState(useDuplicateSpiderfyDefault);
  const [highLiteDuplicates, setHighLiteDuplicates] = useState(highLiteDuplicatesDefault);


  useEffect(() => {
    if (numStops > MAX_STOPS_FOR_DUPLICATE_SPIDERFY) {
      setUseDuplicateSpiderfy(false);
    }
  }, [numStops]);

  return {
    useCluster,
    setUseCluster,
    useDuplicateSpiderfy,
    setUseDuplicateSpiderfy,
    highLiteDuplicates,
    setHighLiteDuplicates
  };
}
